module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074c8_logo_200x200.26e5b95b.png";